<template>
    <footer class="footer" :class="`footer--${name}`" >
        <div class="container">
            <div class="footer--wrapper">
                <ul>
                    <router-link v-for="(route, index) in routes" :key="`footer-router-link-${index}`" tag="li" :to="{ name: route.name }" active-class="active">
                        <a href='#'>{{ route.label }}</a>
                    </router-link>
                </ul>

                <div class="footer--loggedin" >
                    <span href="#" v-if="showLoggedIn">{{ t('nav.footer.logged_in') }} {{t('general.' + userType)}}: {{userName}}</span>
                </div>

                <FooterFlags></FooterFlags>

            </div>
        </div>
    </footer>
</template>
<script>
import { getUser, getUserType } from '@/helpers/auth';
import FooterFlags from '@/components/Footer/FooterFlags';

export default {
    name: 'Footer',

    components: {
        FooterFlags,
    },

    props: {
        name: {
            type: String,
            required: true,
        },

        routes: {
            type: Array,
            required: true,
        },

        showLoggedIn: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        userName() {
            const user = getUser();
            return `${user.first_name} ${user.middle_name ? user.middle_name : ''} ${user.last_name}`;
        },

        userType() {
            return getUserType();
        },

        notLoggedIn() {
            const user = getUserType();
            if (user === null) {
                return true;
            }
            return false;
        },
    },
};
</script>
<style lang="scss" scoped>
.footer {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #efefef;
    text-align: center;
    height: 50px;
    background-color: $primary;
    display:flex;
    align-items: center;


    &--wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        ul {
            margin: 0;
            margin-block-start: 0;
            margin-block-end: 0;
            padding: 0;
            list-style: none;
            display: flex;
            list-style-type: none;
            li {
                a {
                    color:white;
                    padding-right:1rem;
                    text-decoration: none;
                }
                a:after{
                    padding-left:1rem;
                    content: "|";
                }
            }
            li:last-child {
                a:after{
                    content: "";
                }
            }


        }

    }

    &--loggedin{
        span{
            color:white;
        }
    }

}

</style>
